import { Component, Event, EventEmitter, Host, Prop, h } from '@stencil/core';

@Component({
  tag: 'ui-cms-load-more',
  styleUrl: 'ui-cms-load-more.scss',
  shadow: true,
})
export class UiCmsLoadMore {
  @Event() uiLoadMore: EventEmitter;

  @Prop() buttonVariant: 'primary' | 'secondary' | 'tertiary' | 'cta';

  @Prop() hide: boolean;

  render() {
    return this.hide ? null : (
      <Host>
        <sd-button variant={this.buttonVariant} onClick={() => this.uiLoadMore.emit()}>
          <slot name="icon-left" />
          <slot></slot>
          <slot name="icon-right" />
        </sd-button>
      </Host>
    );
  }
}
